import React from 'react'
import { SubmissionsEl } from './elements'
import { H5 } from '../../../../../../../../../Styles/typography'
import 'react-perfect-scrollbar/dist/css/styles.css'
import PerfectScrollbar from 'react-perfect-scrollbar'
import SubmissionsStore from '../../stores/SubmissionsStore'
import Submission from './components/submission'

const Submissions = () => {
  const {
    loading,
    loadFailed,
    submissions,
    activeSubmission,
  } = SubmissionsStore.useContainer()

  return loading || loadFailed ? null : (
    <SubmissionsEl>
      <H5>Submissions (03)</H5>

      <span className='separator' />

      <div className='chapters'>
        <PerfectScrollbar>
          {Object.values(submissions).map(
            ({ submissionId, ...submission }, index) => (
              <Submission
                key={submissionId}
                index={index + 1}
                title={submissionId}
                id={submissionId}
                isActive={submissionId === activeSubmission?.submissionId}
                review={submission.review}
              />
            ),
          )}
          <div className='padding' />
        </PerfectScrollbar>
      </div>
    </SubmissionsEl>
  )
}

export default Submissions
